<template>
  <div>
    <div style="text-align: left" v-if="epreuve.id">
      <a :href="'https://sportips.fr/plateformeResultats/#/epreuve?id=' + epreuve.id" target="_blank"><b-button class="button_link_results">Consulter les résultats complets</b-button></a>
    </div>

    <b-row>
      <b-col md="3">
        <b-form-input v-model="searchFilter" :placeholder="$t('recherche_label')" size="sm"></b-form-input>
      </b-col>
      <b-col md="3">
        <b-form-select v-model="courseFilter" @input="$emit('fetchCourseResultats', courseFilter)" :options="epreuve.list_courses" size="sm"></b-form-select>
      </b-col>
      <b-col md="2" style="text-align: left">
        <b-button-group>
          <b-button size="sm" class="sex_select_button" v-on:click="sexeFilter = ''" v-bind:class="{ sex_selected_button: sexeFilter === '' }">
            <v-icon name="male" />
            <v-icon name="female" />
          </b-button>
          <b-button size="sm" class="sex_select_button" v-on:click="sexeFilter = 'M'" v-bind:class="{ sex_selected_button: sexeFilter === 'M' }">
            <v-icon name="male" />
          </b-button>
          <b-button size="sm" class="sex_select_button" v-on:click="sexeFilter = 'F'" v-bind:class="{ sex_selected_button: sexeFilter === 'F' }">
            <v-icon name="female" />
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <p class="align_left">
      <b>{{ translated_stats }}</b>
    </p>
    <b-table id="table_resultats" hover small :items="resultats" :fields="translated_fields" :tbody-tr-class="row_femme" sort-by="Clt" responsive>
      <!-- TEMPLATE ROW NATION -->
      <template #cell(Nat)="data">
        <img class="flag" :src="'https://sportips.fr/live/img/Flags/' + data.item.nation + '.jpg'" />
      </template>
      <!-- TEMPLATE ROW ECART -->
      <template #cell(Ecart)="data">
        {{ getFirst(data.item.temps_arrondi) }}
      </template>
      <!-- TEMPLATE ROW TEMPS -->
      <template #cell(Temps)="data">
        <span class="temps_tab">{{ data.item.temps_arrondi }}</span>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: ["epreuve"],
  data() {
    return {
      searchFilter: "",
      courseFilter: "",
      sexeFilter: "",
      clubFilter: "",
      catFilter: "",
    };
  },
  methods: {
    getFirst(t) {
      if (t === this.resultats[0].temps_arrondi || t == null) {
        return "-";
      } else {
        var t2 = this.resultats[0].temps_arrondi.split(":");
        var t1 = t.split(":");
        var diff = parseInt(t1[0]) * 3600 + parseInt(t1[1]) * 60 + parseInt(t1[2]) - (parseInt(t2[0]) * 3600 + parseInt(t2[1]) * 60 + parseInt(t2[2]));
        var heure = Math.floor(diff / 3600);
        var heurerest = diff % 3600;
        var minute = Math.floor(heurerest / 60);
        var sec = heurerest % 60;
        var res = "+ " + heure + "h" + minute + "m" + sec + "s";
        return res;
      }
    },
    row_femme(item, type) {
      if (!item || type !== "row") return;
      if (item.sexe === "F") return "row-femme";
    },
  },
  computed: {
    translated_stats() {
      var translated_stats = "";
      var raw_stats = this.epreuve.stats_inscriptions.split("-");
      for (var i = 0; i < raw_stats.length; i++) {
        var raw_item_stat = raw_stats[i].split(":");
        if (raw_item_stat[0].includes("Inscrits")) {
          raw_item_stat[0] = this.$t("inscrits");
        } else if (raw_item_stat[0].includes("Partis")) {
          raw_item_stat[0] = this.$t("partis");
        } else if (raw_item_stat[0].includes("Arrivés")) {
          raw_item_stat[0] = this.$t("arrives");
        } else if (raw_item_stat[0].includes("Abandons")) {
          raw_item_stat[0] = this.$t("abandons");
        }
        translated_stats += raw_item_stat[0] + " : " + raw_item_stat[1];
        if (i < raw_stats.length - 1) {
          translated_stats += " - ";
        }
      }
      return translated_stats;
    },

    translated_fields() {
      var translated_fields = JSON.parse(JSON.stringify(this.epreuve.fields));
      for (var i = 0; i < translated_fields.length; i++) {
        switch (translated_fields[i].label) {
          case "Clt":
            translated_fields[i].label = this.$t("clt");
            break;
          case "Nom - Prénom":
            translated_fields[i].label = this.$t("nom_prenom");
            break;
          case "Doss.":
            translated_fields[i].label = this.$t("doss");
            break;
          case "Clt Cat":
            translated_fields[i].label = this.$t("clt_cat");
            break;
          case "Clt Sexe":
            translated_fields[i].label = this.$t("clt_sexe");
            break;
          case "Temps":
            translated_fields[i].label = this.$t("temps");
            break;
          case "Ecart":
            translated_fields[i].label = this.$t("ecart");
            break;
          case "Moy.":
            translated_fields[i].label = this.$t("moy");
            break;
          case "Club":
            translated_fields[i].label = this.$t("club");
            break;
          case "Licence":
            translated_fields[i].label = this.$t("licence");
            break;

          default:
        }
      }
      return translated_fields;
    },

    resultats() {
      if (!this.epreuve.resultats) {
        return [];
      }
      var filteredTab = this.epreuve.resultats;
      filteredTab = filteredTab.filter((item) => item.temps_arrondi != "00:00:00" && item.abandon != "O" && item.disqualifie != "O");
      if (this.searchFilter) {
        if (!isNaN(this.searchFilter)) {
          filteredTab = filteredTab.filter((item) => item.numero.includes(this.searchFilter));
        } else {
          filteredTab = filteredTab.filter((item) => item.nom.includes(this.searchFilter.toUpperCase()));
        }
      }
      if (this.sexeFilter) {
        filteredTab = filteredTab.filter((item) => item.sexe.includes(this.sexeFilter));
      }
      if (this.clubFilter != "" && this.clubFilter != "Tous") {
        filteredTab = filteredTab.filter((item) => item.club.includes(this.clubFilter));
      }
      if (this.catFilter != "" && this.catFilter != "Toutes") {
        filteredTab = filteredTab.filter((item) => item.abbrev_categorie.includes(this.catFilter));
      }
      for (var i = 0; i < filteredTab.length; i++) {
        if (filteredTab[i].champs_affiches[0] === undefined) {
          filteredTab.splice(i, 1);
        }
      }
      return filteredTab;
    },
    list_cat() {
      var list = [];
      for (var i = 0; i < this.epreuve.resultats.length; i++) {
        if (!list.includes(this.epreuve.resultats[i].abbrev_categorie)) {
          list.push(this.epreuve.resultats[i].abbrev_categorie);
        }
      }
      list.sort();
      list.unshift("Toutes");
      return list;
    },
    list_clubs() {
      var list = [];
      for (var i = 0; i < this.epreuve.resultats.length; i++) {
        if (!list.includes(this.epreuve.resultats[i].club)) {
          list.push(this.epreuve.resultats[i].club);
        }
      }
      list.sort();
      list.unshift("Tous");
      return list;
    },
  },
  mounted() {
    if (this.$route.params.course && this.$route.params.course != "") {
      this.courseFilter = this.$route.params.course;
    }
    if (this.courseFilter === "") {
      this.courseFilter = this.epreuve.list_courses[0];
    }
    this.$forceUpdate();
  },
};
</script>

<style lang="scss" scoped>
</style>